import Parse from 'parse';

export const GetTaskStates = async () => {
    const taskState = Parse.Object.extend("TaskState");
    const taskStateListQuery = new Parse.Query(taskState).addAscending('order').limit(10000);

    return await taskStateListQuery.find();
}
